import React, { createContext, useContext, useState, ReactNode } from 'react';
import { getMaskedEmail } from '../utils';

type LoginContextType = {
  email: string;
  username: string;
  password: string;
  setEmail: (email: string) => void;
  setPassword: (password: string) => void;
  setUsername: (username: string) => void;
  maskedEmail: string;
};

const LoginContext = createContext<LoginContextType | undefined>(undefined);

export const LoginProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [email, setEmail] = useState<string>('');
  const [username, setUsername] = useState<string>('');
  const [password, setPassword] = useState<string>('');

  return (
    <LoginContext.Provider value={{ username, setUsername, email, password, setEmail, setPassword, maskedEmail: getMaskedEmail(email), }}>
      {children}
    </LoginContext.Provider>
  );
};

// Custom hook to use the LoginContext
export const useLogin = (): LoginContextType => {
  const context = useContext(LoginContext);
  if (!context) {
    throw new Error('userLogin must be used within an LoginProvider');
  }
  return context;
};

